import { Component } from 'react';

import { EmbeddedQuery } from '../../shared/EmbeddedQueryParser';
import Footer from '../Footer/Footer';
import Main from '../Main';
import Topbar from '../Topbar';
import { LayoutProps } from './MainLayout';
import css from './StoreLocatorPageLayout.css';

interface StoreLocatorPageLayoutProps extends LayoutProps {
  embeddedQuery?: EmbeddedQuery;
}

export default class StoreLocatorPageLayout extends Component<StoreLocatorPageLayoutProps, {}> {
  render() {
    const {
      appState,
      children,
      embeddedQuery: { embed },
    } = this.props;
    const showFooter = !appState.store.isShowroom();

    if (embed) {
      return <div className={css.StoreLocatorPageLayout}>{children}</div>;
    }

    return (
      <div className={css.StoreLocatorPageLayout}>
        <Topbar appState={appState} translation={appState.translation.layout.topBar} />
        <Main className={css.content}>{children}</Main>
        {showFooter && (
          <Footer
            data={appState.navigationState.footer}
            homeUrl={appState.navigationState.homeUrl}
            storeContext={appState.storeResponse.storeContext}
          />
        )}
      </div>
    );
  }
}
